import React, { useState } from 'react'

import './styles.scss'
import ModalWrapper from 'components/ModalWrapper'
import ColorPickerInput from 'components/ColorPickerInput'
import InputField from '../../InputField'
import { lang } from 'utils/helpers'

const Modal = props => {
  const { isOpen, toggle, data, onSave, loading, error } = props
  const [inputValue, setInputValue] = useState(data?.name || '')
  const [colorValue, setColorValue] = useState(data?.color || '#E87721')

  return (
    <ModalWrapper
      isOpen={isOpen}
      toggle= {toggle}
      header={lang('dashboard_add-label')}
      legend={lang('dashboard_add-label-translation')}
      body={
        <div className='translations-labels-section-modal'>
          <InputField
            withSearchIcon={false}
            placeholder={lang('dashboard_label-name')}
            inputValue={inputValue}
            onChangeInput={setInputValue}
          />
          <ColorPickerInput
            color={colorValue}
            setColor={setColorValue}
          />
        </div>
      }
      eventBtnTxt={lang('dashboard_save')}
      eventBtn={() => onSave({ name: inputValue, color: colorValue })}
      cancelBtnTxt={lang('dashboard_cancel')}
      cancelBtn={toggle}
      isSubmitting={loading}
      error={error}
    />
  )
}

export default Modal
